import i18n, { TFunctionKeys, TFunctionResult } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector, { DetectorOptions } from 'i18next-browser-languagedetector'

import fr from 'translations/fr'
import en from 'translations/en'

type Language = 'fr' | 'en'
const options: DetectorOptions = {
  order: ['navigator', 'localStorage', 'querystring']
}
// https://react.i18next.com/

i18n
  .use(initReactI18next)
  .use(LanguageDetector) // passes i18n down to react-i18next
  .init({
    resources: { en: { translation: en }, fr: { translation: fr } },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    load: 'languageOnly',
    detection: options
  })

// Exports the t function that is internal to i18n
// the ...args makes sure all arguments passed are actually passed to the internal function
export const t = (...args: [translation: TFunctionResult, opt?: TFunctionResult]): string => i18n.t(...(args as [string, TFunctionKeys]))

export const changeLang = async (lang: Language): Promise<void> => {
  await setLanguage(lang)
}

export const setLanguage = async (lang: Language): Promise<void> => {
  await i18n.changeLanguage(lang)
}

export default i18n

export const currentLang = (upperCase?: boolean): string => {
  // Get the current language from i18n
  let currentLang = i18n.language

  // If the language is in an other format then ours (en-CA, fr-CA, etc) parse it to one of our format
  if (currentLang.includes('-')) currentLang = currentLang.split('-')[0]
  // Return the language in lowercase
  if (!upperCase) return currentLang.toLowerCase()
  // Return in upperCase
  return currentLang.toUpperCase()
}
